import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";
import { GeoRehandleDiggerDTO } from "../../../DTOs/Geology/GeoRehandleDiggerDTO";

type DiggerCellProps = {
  entry: GeoRehandleDTO,
  diggerOptions: GeoRehandleDiggerDTO[],
  isDiggerOptionsLoading: boolean
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isReadOnly: boolean
}

const DiggerCell: React.FC<DiggerCellProps> = ({
  entry,
  diggerOptions,
  isDiggerOptionsLoading,
  handleUpdateRow,
  isReadOnly
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      disabled={isReadOnly}
      classes={{ root: 'w-full' }}
      size="small"
      loading={isDiggerOptionsLoading || isLoading}
      options={diggerOptions}
      value={diggerOptions.find(x => x.operationId === entry.operationId) ?? null}
      isOptionEqualToValue={(option, value) => option.operationId === value.operationId}
      getOptionLabel={(option) => option.plantRef}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, operationId: newValue.operationId }
          );
          setLoading(false);
        }
      }}
      renderInput={(params) => <TextField
        {...params}
        label="Digger"
        slotProps={{
          ...params.slotProps,
          input: {
            ...params.slotProps.input,
            endAdornment: (
              <>
                {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />
  );
};

export default DiggerCell;